import { useEffect } from 'react';
import "./EditBlog.css"
import ReactQuill from "react-quill";
import { useState } from 'react';
import "../../../node_modules/react-quill/dist/quill.snow.css";
import { FiUploadCloud } from "react-icons/fi";
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GetsingleBlog, UpdateBlogs } from '../../actions/BlogAction';
import axios from 'axios';
import { toast } from 'react-toastify';
import { WithContext as ReactTags } from 'react-tag-input';
import { mainurl } from '../../actions/mainurl';

const KeyCodes = {
  comma: 188,
  enter: 13
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

function EditBlog() {

  const [tags, setTags] = useState([]);

  const handleDelete = i => {
    const newTags = [...tags];
    newTags.splice(i, 1);
    setTags(newTags);
  };


  const handleAddition = tag => {
    setTags([...tags, tag]);
  };

  const handleDrag = (tag, currPos, newPos) => {
    const newTags = tags.slice();

    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);

    // re-render
    setTags(newTags);
  };

  const handleTagClick = index => {
    console.log('The tag at index ' + index + ' was clicked');
  };


  const { Singleblog } = useSelector((state) => state.blog)


  const navigator = useNavigate()
  const dispatch = useDispatch();

  const [image, setImage] = useState(null);
  const [defaultImage, setDefaulImage] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [allCategory, setAllCategory] = useState([]);
  const [values, setValue] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [description, setDescription] = useState("");
  const [metaKeyWord, setMetaKeyWord] = useState("");
  const [heading, setHeading] = useState("");
  const [content, setContent] = useState("");
  const [url, setUrl] = useState("");
  const [newTag, setNewTag] = useState([]);

  const baseurl = mainurl

  const params = useParams()
  useEffect(() => {
    dispatch(GetsingleBlog(params.id))
  }, [dispatch, params.id])



  // blog image
  const handleImage = (e) => {
    const reader = new FileReader();

    reader.onload = () => {
      if (reader.readyState === 2) {
        setDefaulImage(reader.result);
        setImage(e.target.files[0]);
      }
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  // category
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  // react quill funtion
  const handleChange = (e) => {
    setValue(e);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("mainheading", heading);
    formData.append("maincontent", content);
    formData.append("content", values);
    formData.append("meta_description", description);
    formData.append("meta_keywords", metaKeyWord);
    formData.append("meta_title", metaTitle);
    formData.append("imageurl", image);
    formData.append("category", selectedOption);
    formData.append("url", url);
    // Convert tags array to a string before appending it
    const tagsString = JSON.stringify(tags);
    const parsetag = JSON.parse(tagsString)
    const tagmap = parsetag.map(tag => tag.text)
    setNewTag(tagmap)
    formData.append("tags", newTag ? newTag.concat(tagmap) : tagmap);


    try {
      await dispatch(UpdateBlogs(params.id, formData));
      handleCategory()
      navigator('/allblogs');
    } catch (error) {
      console.error('Error updating new blog:', error);
    }
  }


  useEffect(() => {
    if (Singleblog) {
      setSelectedOption(Singleblog.category)
      setDefaulImage(Singleblog.imageurl)
      setHeading(Singleblog.mainheading)
      setContent(Singleblog.maincontent)
      setMetaTitle(Singleblog.meta_title)
      setMetaKeyWord(Singleblog.meta_keywords)
      setDescription(Singleblog.meta_description)
      setValue(Singleblog.content)
      setUrl(Singleblog.url)
      setNewTag(Singleblog.tags)
    }
  }, [Singleblog])


  const handleCategory = async () => {

    try {
      await axios.post(`${baseurl}/blog/create-category`, { "category": selectedOption }, { withCredentials: true })

    } catch (error) {
      console.log(error);
    }

  }
  useEffect(() => {
    const loadCategories = async () => {
      try {
        const { data } = await axios.get(`${baseurl}/blog/get-select-category`, { withCredentials: true });
        setAllCategory(data.value);
      } catch {
        toast.error("Already have category");
      }
    };

    loadCategories();
  }, [baseurl])

  return (
    <div className='create_main_div'>
      <div className='create_div'>
        <form onSubmit={handleSubmit} className='create_div'>
          <div className='input_div'>
            <div className='input_name'>Blog Image</div>
            <label htmlFor="image" className="custom-file-input">
              {<img src={image ? defaultImage : defaultImage} alt="" />}
              <FiUploadCloud className='upload_icon' />
            </label>
            <input type="file" onChange={handleImage} name="image" id="image" style={{ display: 'none' }} />
          </div>

          <div className='input_div'>
            <div className='input_name'>Category</div>
            <select className="create_input" value={selectedOption} onChange={handleOptionChange}>
              <option value="">Select page</option>
              {
                allCategory?.map((item) => {
                  return <option key={item} value={item}>{item}</option>
                })
              }
            </select>
          </div>
          <div className='input_div'>
            {
              selectedOption ?
                <>   <div className="input_name">Create a Category</div>
                  <input
                    className="create_input"
                    type="text"
                    value={selectedOption}
                    onChange={(e) => setSelectedOption(e.target.value)}
                  />
                </> :
                <>
                  <div className="input_name">Create a Category</div>
                  <input
                    className="create_input"
                    type="text"
                    value={selectedOption}
                    onChange={(e) => setSelectedOption(e.target.value)}
                  />

                </>
            }
          </div>
          <div className='input_div'>
            <div className='input_name'>Url</div>
            <input className='create_input'
              type="text"
              // placeholder="Enter the meta_title"
              value={url}
              onChange={(e) => setUrl(e.target.value)} />
          </div>
          <div className='input_div'>
            <div className='input_name'>Tags</div>
            <ReactTags
              tags={tags}
              delimiters={delimiters}
              handleDelete={handleDelete}
              handleAddition={handleAddition}
              handleDrag={handleDrag}
              handleTagClick={handleTagClick}
              inputFieldPosition="bottom"
              autocomplete
            />

          </div>
          <div className='input_div'>
            <div className='input_name'>Meta Title</div>
            <input className='create_input'
              type="text"
              // placeholder="Enter the meta_title"
              value={metaTitle}
              onChange={(e) => setMetaTitle(e.target.value)} />
          </div>
          <div className='input_div'>
            <div className='input_name'>Meta Description</div>
            <input className='create_input'
              type="text"
              // placeholder="Enter The meta_description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div className='input_div'>
            <div className='input_name'>Meta Keyword</div>
            <input className='create_input'
              type="text"
              // placeholder="Enter The meta_keywords"
              value={metaKeyWord}
              onChange={(e) => setMetaKeyWord(e.target.value)}
            />
          </div>
          <div className='input_div'>
            <div className='input_name'>Blog Title</div>
            <input className='create_input' type="text"
              // placeholder="Enter The Heading"
              value={heading}
              onChange={(e) => setHeading(e.target.value)} />
          </div>
          <div className='input_div'>
            <div className='input_name'>Blog Content</div>
            <textarea className='create_text_area'
              type="text"
              // placeholder="Enter some Content..."
              value={content}
              onChange={(e) => setContent(e.target.value)}
            />
          </div>
          <div className='input_div'>
            <div className="input_name">Blog details description</div>
            <ReactQuill
              className="text_area"
              placeholder="write some thing"
              formats={EditBlog.formats}
              modules={EditBlog.modules}
              value={values}
              onChange={handleChange}
            />
          </div>
          <div className="submit_buttons">
            <input
              type="submit"
              value={"submit"}
              className='create_input_button'
            />
          </div>
        </form>
      </div>
    </div>
  )
};

EditBlog.modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ],
};
EditBlog.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "color",
  "background",
  "list",
  "bullet",
  "indent",
  "link",
  "video",
  "image",
  "code-block",
  "align",
];


export default EditBlog
